import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { getLenis } from '../utils/lenis';

gsap.registerPlugin(ScrollTrigger);

const MINIMUM_SCROLL_DISTANCE = 50;

function ScrollToTopButton() {
  const wrapRef = useRef(null);
  const buttonRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useGSAP(() => {
    const buttonWrap = wrapRef.current;
    const button = buttonRef.current;

    if (!buttonWrap || !button) {
      return undefined;
    }

    gsap.set(buttonWrap, { autoAlpha: 1 });
    gsap.set(button, { autoAlpha: 0, rotate: -65, scale: 0.6 });

    const trigger = ScrollTrigger.create({
      trigger: document.body,
      start: `top top-=${MINIMUM_SCROLL_DISTANCE}%`,
      onEnter: () => {
        gsap.to(button, {
          autoAlpha: 1,
          rotate: 0,
          scale: 1,
          duration: 0.45,
          ease: 'power4.out',
        });
      },
      onLeaveBack: () => {
        gsap.to(button, {
          autoAlpha: 0,
          rotate: -65,
          scale: 0.6,
          duration: 0.4,
          ease: 'power4.out',
        });
      },
    });

    return () => {
      trigger.kill();
      gsap.killTweensOf(button);
    };
  }, []);

  const scrollToTop = () => {
    const lenis = getLenis();

    if (lenis) {
      lenis.scrollTo(0);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!mounted) {
    return null;
  }

  return createPortal(
    <div ref={wrapRef} data-back-to-top='wrap' className='back-top__wrap'>
      <button
        ref={buttonRef}
        type='button'
        data-back-to-top='button'
        className='back-top__button'
        aria-label='Back to top'
        onClick={scrollToTop}
      >
        <div className='back-top__arrow-wrap'>
          <div className='back-top__arrow-row'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 60 60'
              fill='none'
              className='back-top__arrow'
              aria-hidden='true'
            >
              <path
                d='M47.5 25L30 7.5L12.5 25'
                stroke='currentColor'
                strokeWidth='6'
                strokeMiterlimit='10'
                strokeLinecap='round'
              ></path>
              <path
                d='M30 7.5L30 55'
                stroke='currentColor'
                strokeWidth='6'
                strokeMiterlimit='10'
                strokeLinecap='round'
              ></path>
            </svg>
          </div>
          <div className='back-top__arrow-row'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 60 60'
              fill='none'
              className='back-top__arrow'
              aria-hidden='true'
            >
              <path
                d='M47.5 25L30 7.5L12.5 25'
                stroke='currentColor'
                strokeWidth='6'
                strokeMiterlimit='10'
                strokeLinecap='round'
              ></path>
              <path
                d='M30 7.5L30 55'
                stroke='currentColor'
                strokeWidth='6'
                strokeMiterlimit='10'
                strokeLinecap='round'
              ></path>
            </svg>
          </div>
        </div>
      </button>
    </div>,
    document.body
  );
}

export default ScrollToTopButton;
